var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('PercentageGraph',{attrs:{"visible":"","data":_vm.graphData,"title":_vm.graphTitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }